import { UseInfiniteQueryOptions } from '@tanstack/react-query';
import { ApiModel, ListingSellerModel, ListingSellerModelConverter } from '@steelbuy/ts-shared';
import { ResponseModel } from '../../utils/types';
import { usePaginatedQuery } from '../../utils/usePaginatedQuery';

export const MY_LISTINGS_KEY = 'listings';

const modelConverter = new ListingSellerModelConverter();
const searchListingMapFn = (data: ListingSellerModel) =>
    modelConverter.toViewModel(data as unknown as ApiModel<ListingSellerModel>);

export const useMyListings = ({
    filterCriteria,
    queryOptions,
}: {
    filterCriteria?: Record<string, string>;
    queryOptions?: Omit<
        UseInfiniteQueryOptions<ResponseModel<ListingSellerModel[]>>,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >;
}) =>
    usePaginatedQuery<ListingSellerModel>({
        url: '/api/universal/listings',
        requestOptions: {
            filter: filterCriteria,
        },
        mapFn: searchListingMapFn,
        queryKey: [MY_LISTINGS_KEY, filterCriteria],
        queryOptions: {
            refetchOnMount: false,
            ...queryOptions,
        },
    });
